import { AppState } from '@auth0/auth0-react'
import { createContext } from 'react'

type PostLoginContextType = {
  appState?: AppState
}
export const PostLoginContext = createContext<PostLoginContextType>({})
